import { TrlFormattedMessagePlain } from '»utils/i18n';

export const columns = () => [
  {
    title: ' ',
    field: 'dummy',
    width: 5,
    locked: true,
  },
  {
    field: 'descr',
    title: TrlFormattedMessagePlain({ id: 'TRLT_UI-SECURITY' }),
    cellTemplate: 'TrlButtonCell',
    type: 'uppercasecell',
    minWidth: 140,
  },
  {
    field: 'space',
  },
  {
    field: 'lastPx',
    title: TrlFormattedMessagePlain({ id: 'TRLT_UI-PRICE' }),
    cellTemplate: 'TrlButtonCell',
    type: 'numeric',
    decimalDigits: 'roundPrice',
    endDecoratorKey: 'priceRepresentation',
    headerClassName: 'customClassRight',
    className: 'customClassRight',
    minWidth: 96,
  },
  {
    field: 'space',
  },
  {
    field: 'lastDateTime',
    title: TrlFormattedMessagePlain({ id: 'TRLT_UI-HOUR' }),
    cellTemplate: 'TrlButtonCell',
    type: 'timesec',
    headerClassName: 'customClassCenter',
    className: 'customClassCenter',
    minWidth: 100,
  },
  {
    field: 'space',
  },
  {
    field: 'variationPctg',
    title: TrlFormattedMessagePlain({ id: 'TRLT_UI-DAILY_CHANGE' }),
    cellTemplate: 'TrlButtonCell',
    type: 'numeric',
    decimalDigits: 'roundPrice',
    headerClassName: 'customClassRight',
    className: 'customClassRight',
    visualEffect: 'variationPctg',
    hasVisualEffectAttr: true,
    isMarketStockExchange: true,
    endDecorator: '%',
    minWidth: 111,
  },
];
